import angular from 'angular';
import indonesianActionsPanel from './indonesianActionsPanel';

export default angular
  .module('components.indonesianActionsPanel', [])
  .component('indonesianActionsPanel', indonesianActionsPanel).name;
